import { Phone } from 'lucide-react';
import { Link } from 'react-router';

import { paths } from '@/app/routes/paths';
import { ClinicPhoneLink } from '@/components/common/ClinicPhoneLink';
import { OptimizedImage } from '@/components/common/OptimizedImage';
import { clinicSettings } from '@/data/clinic';

const HeaderBrand = () => (
  <>
    <div className="bg-primary text-primary-foreground text-base flex justify-between">
      <div className="max-w-screen-lg w-full mx-auto text-left px-4 py-1">
        <span>東御市の歯科、小児歯科</span>
      </div>
    </div>

    <div className="flex flex-col md:flex-row items-center justify-between py-4 md:py-3 max-w-screen-lg mx-auto px-4 gap-4 md:gap-0">
      <div className="flex-shrink-0">
        <Link to={paths.root} className="block">
          <OptimizedImage
            src="/img/logo.png"
            alt="小林歯科医院ロゴ"
            className="h-12 md:h-15 w-auto object-contain"
          />
        </Link>
      </div>

      <div className="hidden md:block flex-grow" />

      <div className="flex items-center gap-2 text-primary shrink-0">
        <Phone className="w-6 h-6 md:w-7 md:h-7" />
        <ClinicPhoneLink
          className="font-semibold tracking-wide text-2xl md:text-3xl align-middle whitespace-nowrap"
        >
          {clinicSettings.phone.display}
        </ClinicPhoneLink>
      </div>
    </div>
  </>
);

export default HeaderBrand;
